var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginContainer"},[_c('div',{staticClass:"loginBox contentBox"},[_c('div',[_c('button',{on:{"click":_vm.login}},[_vm._v("Login With Google")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }